import { TranslateService } from '@ngx-translate/core';
import { Component, ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { v4 as uuidv4 } from 'uuid';


export interface MenuMoreOption {
  Id: number;
  Text: string;
  Icon: string;
  Alt: string,
  Class?: string;
  DisabledMessage?: string;
}

@Component({
  selector: 'app-more-options-table-row',
  templateUrl: './more-options-table-row.component.html',
  styleUrls: ['./more-options-table-row.component.scss']
})
export class MoreOptionsTableRowComponent {

  @Input() maxWidth: string = "";
  @Input() top: string = "0px";
  @Input() right: string = "29px";
  @Input() width: string | undefined;

  uniqueId: string = uuidv4();

  openDropdown: boolean = false;

  @Input() menuOptions: MenuMoreOption[] = [];

  @Output() optionEmitter = new EventEmitter<number>()

  constructor(private translateService: TranslateService, private elementRef: ElementRef) {

  }

  ngOnInit() {
    if (this.menuOptions == null || this.menuOptions?.length == 0) {
      // DEFAULT OPTIONS AND EXAMPLE OF OPTIONS TODO ON PARENT COMPONENTE
      this.menuOptions = [
        { Id: 1, Text: this.translateService.instant('MORE_OPTIONS.EDIT'), Icon: 'assets/icons/pencil-alt.svg', Alt: this.translateService.instant('MORE_OPTIONS.EDIT') },
        { Id: 2, Text: this.translateService.instant('MORE_OPTIONS.DETAIL'), Icon: 'assets/icons/datatable-eye.svg', Alt: this.translateService.instant('MORE_OPTIONS.DETAIL') },
        { Id: 3, Text: this.translateService.instant('MORE_OPTIONS.DELETE'), Icon: 'assets/icons/datatable-trash-red.svg', Alt: this.translateService.instant('MORE_OPTIONS.DELETE'), Class: 'red-span' }
      ]
    }
  }

  toggleDropdown() {
    this.openDropdown = !this.openDropdown;
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    const targetElement = event.target as HTMLElement;
    const element = document.getElementById(this.uniqueId);
    if (this.openDropdown && element && !element.contains(targetElement)) {
      this.openDropdown = false;
    }
  }
  optionEmit(event: number) {
    this.optionEmitter.emit(event)
    this.openDropdown = false;
  }
}
